<template>
  <div class="campaign-list-status">
    <span class="status-label">
      Status:
    </span>

    <div
      v-if="status === 'DOWNLOADED'"
      class="status-wrap"
    >
      <span class="status">
        Downloaded
      </span>
    </div>

    <div
      v-if="status === 'DRAFT'"
      class="status-wrap"
    >
      <span class="status">
        Draft
      </span>
    </div>

    <div
      v-if="status === 'SENT'"
      class="status-wrap"
    >
      <span class="status">
        Sent
      </span>
    </div>

    <div
      v-if="status === 'ARCHIVED'"
      class="status-wrap"
    >
      <span class="status">
        Archived
      </span>
    </div>

    <div
      v-if="status === 'SENDING'"
      class="status-wrap"
    >
      <span class="status">
        Sending
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignListStatus",
  props: {
    status: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.campaign-list-status {
  @apply text-xs flex text-grey-darker;

  @screen sm {
    @apply text-sm;
  }
}

.status-label {
  @apply mr-1 font-bold;
}

.status-wrap {
  @apply flex;
}

.status {
  @apply block text-grey-darker;
}
</style>
